import moment from "moment";
import { LoadState } from "../../constants/enums";
import { STANDARD_APP_DATE_FORMAT } from "../../constants/constants";


// export interface IOnlineDsaLimit {
// 	online_dsa_activation_id: number;
// 	online_dsa_name: string;
// 	user_id: number;
// 	referral_code: string;
// 	package_id: number;
// 	package_name: string;
// 	total_activations_limit: number;
// 	total_activated: number;
// 	activation_limit_remaining: number;
// 	comment: string;
// 	status: "ACTIVE" | "INACTIVE";
// 	create_dt: string | null;
// 	insert_dt: string | null;
// }

export interface IOnlineDsaLimitState {
  list: {
	list: IOnlineDsaLimit[];
	totalRecords: number;
	loading: LoadState;
	error: string | null;
  };
  OnlineDsa: {
	data: IOnlineDsaLimit;
	loading: LoadState;
	error: string | null;
  };
  generalHistory: {
	list: IGeneralHistory[];
	loading: LoadState;
  };
  recordCounts: {
	list: IonlineDsaStatusCount[];

	loading: LoadState;
  };
}

export interface IOnlineDsaLimit {
  leads_uuid: string;
  lead_code: string;
  name: string;
  industry_type: string;
  customer_type: "";
  contact_number: string;
  
  email: string;
  city: string;
  company_name: string;
  representative_name: string;
  representative_email: string;
  representative_contact: string;
  designation: string;
  alternate_contact: string;
  visited_date: string;
  function_date: string;
  followup_date: string;
  followup_time_slot: string | null;
  next_followup_date: string;
  company_outlet_uuid: string | null;
  company_outlet_name: string | null;
  event_type: string;
  event_time: string;
  event_time_uuid: string;
  number_of_guests: number;
  preferred_venue: string;
  preferred_venue_uuid: string;
  commercials: {
	description: string[];
	value: string[];
  }[];
  description: string;
  status:
	| "ENGAGED"
	| "DEAD_LEAD"
	| "BOOKED"
	| "POSTPONED"
	| "PROSPECT"
	| "ONGOING"
	| "INACTIVE"
  | "ACTIVE"
	| "BOOKED";
  created_by_uuid: string;
  created_by_name: string;
  modified_by_uuid: string;
  modified_by_name: string;
  handled_by_employee: string;
  handled_by_employee_uuid: string;
  create_ts: string;
  insert_ts: string;
  whatsapp_status: string | null;
  remarks: string | null;
  event_type_uuid: string;
  customer_type_uuid: string;
  source_of_interaction: string;

  proposal?: "PROPOSAL_SEND" | "DEAL_SEND" | "QUOTATION_SEND" | null;

  dynamic_field?: Array<{
	field_name: string;
	field_type: string;
	field_value: string | number | null;
  }>;
  [key: string]: any; // Allow any additional properties
}

export const initialLead: IOnlineDsaLimit = {
  leads_uuid: "",
  lead_code: "",
  name: "",
  industry_type: "",
  customer_type: "",
  contact_number: "",
  email: "",
  city: "",
  company_name: "",
  representative_name: "",
  company_outlet_uuid: "",
  company_outlet_name: "",
  representative_email: "",
  representative_contact: "",
  designation: "",
  alternate_contact: "",
  visited_date: new Date().toISOString(),
  function_date: new Date().toISOString(),
  followup_date: new Date().toISOString(),
  followup_time_slot: null,
  next_followup_date: "",
  event_type: "",
  event_time: "",
  event_time_uuid: "",
  number_of_guests: 0,
  preferred_venue: "",
  preferred_venue_uuid: "",
  commercials: [
	{
	  description: [""],
	  value: [""],
	},
  ],
  description: "",
  status: "ONGOING",
  created_by_uuid: "",
  created_by_name: "",
  modified_by_uuid: "",
  modified_by_name: "",
  handled_by_employee: "",
  handled_by_employee_uuid: "",
  create_ts: new Date().toISOString(),
  insert_ts: new Date().toISOString(),
  whatsapp_status: null,
  remarks: null,
  event_type_uuid: "",
  customer_type_uuid: "",
  source_of_interaction: "",
  proposal: "PROPOSAL_SEND",
};

export const initialLeadState: IOnlineDsaLimitState = {
  list: {
	list: [],
	totalRecords: 0,
	loading: LoadState.NotLoaded,
	error: null,
  },
  OnlineDsa: {
	data: initialLead,
	loading: LoadState.NotLoaded,
	error: null,
  },
  generalHistory: {
	list: [],
	loading: LoadState.NotLoaded,
  },
  recordCounts: {
	list: [],

	loading: LoadState.NotLoaded,
  },
};

export interface IonlineDsaStatusCount {
  [key: string]: number;
}

export interface IGeneralHistory {
  insert_ts: string;
  [key: string]: any;
}
